import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import {
	GetArticlesDocument,
	GetArticlesQuery,
	GetArticlesQueryVariables,
} from '@/features/editorial/graphql/queries/GetArticles.query';
import { BackdropProfile, ImageFormat } from '@/@types/graphql-types';
import { useQuery } from '@/helpers/composables/useApollo';
import { getHeaderImage } from '@/features/editorial/helpers/editorial-helper';

export function useArticles({
	articleId,
	sortByTrending = false,
	amount = 7,
}: {
	articleId?: number | null;
	sortByTrending?: boolean;
	amount?: number;
}) {
	const { language, country } = storeToRefs(useLanguageStore());

	const queryVariables = computed(() => {
		return {
			country: country.value,
			language: language.value,
			first: amount,
			profile: BackdropProfile.S640,
			format: ImageFormat.Webp,
			articlesFilter: {
				relatedArticleId: articleId,
				sortByTrending,
			},
		};
	});

	const { result } = useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, queryVariables);

	const articles = computed(() =>
		result.value?.articles.edges?.map(article => ({ ...article.node, headerImage: getHeaderImage(article.node) }))
	);

	return {
		articles,
	};
}
